import { CommentSort } from "../constants/CommentSort"
import { IComment } from "../types/IComment"

const sortComments = <T extends IComment<T, TMention, TRole>, TMention, TRole>(comments: T[], sort: CommentSort) => {
  return comments.sort((a, b) =>
    sort === CommentSort.asc
      ? +new Date(a.date) - +new Date(b.date)
      : +new Date(b.date) - +new Date(a.date)
  )
}

export const processComments = <T extends IComment<T, TMention, TRole>, TMention, TRole>(comments: T[], search: string, sort: CommentSort): T[] => {
  let result = comments
  
  if (search) {
    result = result.filter(({ name, text }) =>
      (name || "").toLowerCase().includes(search.toLowerCase())
      || (text || "").toLowerCase().includes(search.toLowerCase()))
  }

  result = result.reduce((result: T[], item) => {
    if (item.parentId) {
      const parent = result.find(({ id }) => id === item.parentId)
        ?? comments.find(({ id }) => id === item.parentId)

      if (!parent) {
        return result
      }

      return [
        ...result.filter(({ id }) => id !== item.parentId),
        { ...parent, replies: [...parent.replies || [], item] }
      ]
    }

    return [...result, item]
  }, [])

  result = sortComments(result, sort)

  return result.map(comment => ({
    ...comment,
    replies: sortComments(comment.replies || [], sort)
  }))
}
